import {
    VOUCHER_VALIDATE_REQUEST,
    VOUCHER_VALIDATE_SUCCESS,
    VOUCHER_VALIDATE_FAIL,
    VOUCHER_VALIDATE_RESET,
    VOUCHER_REMOVE
} from '../constants/voucherConstants';

export const voucherValidateReducer = (state = {}, action) => {
    switch (action.type) {
        case VOUCHER_VALIDATE_REQUEST:
            return { loading: true };

        case VOUCHER_VALIDATE_SUCCESS:
            return {
                loading: false,
                success: true,
                voucher: action.payload.voucher,
                discountAmount: action.payload.discount_amount,
                itemDiscountAmount: action.payload.item_discount_amount,
                shippingDiscountAmount: action.payload.shipping_discount_amount,
                freeShippingApplied: action.payload.free_shipping_applied,
                message: action.payload.message
            };

        case VOUCHER_VALIDATE_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case VOUCHER_REMOVE:
        case VOUCHER_VALIDATE_RESET:
            return {};

        default:
            return state;
    }
};
